export default "__VITE_ASSET__FdPn1pqy__"